export default "__VITE_ASSET__BKpzIQr4__"